import React from 'react';
import './FuturaRetornoTechnicianTabs.css';

/**
 * Abas Pendente / Liberado no header da seção FUTURA (coluna do técnico).
 */
export function FuturaRetornoTechnicianTabs({
  futuraHeaderTab,
  setFuturaHeaderTab,
  futuraPendenteOrdersAll,
  futuraLiberadoOrdersAll
}) {
  const nPendente = futuraPendenteOrdersAll.length;
  const nLiberado = futuraLiberadoOrdersAll.length;

  React.useEffect(() => {
    if (nPendente === 0 && nLiberado === 0 && futuraHeaderTab != null) {
      setFuturaHeaderTab(null);
    }
  }, [nPendente, nLiberado, futuraHeaderTab, setFuturaHeaderTab]);

  if (nPendente === 0 && nLiberado === 0) {
    return null;
  }

  return (
    <div className="service-group-futura-tabs" role="tablist" aria-label="Visão FUTURA">
      <button
        type="button"
        role="tab"
        aria-selected={futuraHeaderTab === 'pendente'}
        className={`service-group-futura-tab${futuraHeaderTab === 'pendente' ? ' service-group-futura-tab--active' : ''}`}
        onClick={() => setFuturaHeaderTab((v) => (v === 'pendente' ? null : 'pendente'))}
      >
        Pendente
        <span
          className={`service-group-futura-tab-count${nPendente > 0 ? ' service-group-futura-tab-count--pendente-hot' : ''}`}
        >
          {nPendente}
        </span>
      </button>
      <span className="service-group-futura-tab-sep" aria-hidden="true" />
      <button
        type="button"
        role="tab"
        aria-selected={futuraHeaderTab === 'liberado'}
        className={`service-group-futura-tab${futuraHeaderTab === 'liberado' ? ' service-group-futura-tab--active' : ''}`}
        onClick={() => setFuturaHeaderTab((v) => (v === 'liberado' ? null : 'liberado'))}
      >
        Liberado
        <span
          className={`service-group-futura-tab-count${nLiberado > 0 ? ' service-group-futura-tab-count--liberado-hot' : ''}`}
        >
          {nLiberado}
        </span>
      </button>
    </div>
  );
}
